import { render, staticRenderFns } from "./SubmissionsFilter.vue?vue&type=template&id=4acf97fa&"
import script from "./SubmissionsFilter.vue?vue&type=script&lang=js&"
export * from "./SubmissionsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports